import { useState, useEffect } from 'react';
import { getPassLevels } from '../utils/api';

const FALLBACK = ['SL', 'AA Pass', 'Media Pass'];

export function usePassLevels() {
  const [passLevels, setPassLevels] = useState(FALLBACK);
  useEffect(() => {
    getPassLevels()
      .then(d => { if (Array.isArray(d) && d.length > 0) setPassLevels(d); })
      .catch(() => {});
  }, []);
  return passLevels;
}
